import { SvgIconProps } from "@mui/material";

const Logo = (props: SvgIconProps) => {
  return (
    <svg
      width={props.width ?? "94.2px"}
      height={props.height ?? "34.61932px"}
      viewBox="0 0 94.2 34.61932"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Group-22" fill="#e97116">
          <path
            d="M4.49862,12.92022 C4.49954,12.93652 4.5,12.95182 4.5,12.96622 C4.6,21.45762 4.6,21.56382 4.6,30.05522 C4.6,30.47982 4.5,31.22282 4,31.96582 C3.2,33.13332 1.6,33.55792 0,33.02722 L1.7,33.87632 C4.9,35.15012 7.1,34.19482 7.1,34.19482 C10.1,33.34562 9.9,28.99382 9.9,28.99382 C9.85,24.85422 9.825,22.83752 9.8,20.82082 C9.77556,18.84882 9.75111,16.87682 9.70329,12.92022 L4.49862,12.92022 Z"
            id="Path"
          ></path>
          <path
            d="M11.3,34.30092 L15.6,27.18932 C15.6,27.18932 16.2,33.55792 19.6,34.40702 L11.3,34.30092 Z"
            id="Path"
            fillRule="nonzero"
          ></path>
          <path
            d="M21.5,11.16162 L26.1,2.13949 L37.4,30.47962 C37.4,30.47962 39.4,34.08852 40.8,34.30082 C40.8,34.30082 40.8,34.30082 40.9,34.30082 C42.3,34.51302 28.5,34.40692 28.5,34.40692 C28.5,34.40692 30.9,28.46292 28.9,24.42952 C26.9,20.39602 21.5,11.16162 21.5,11.16162 Z"
            id="Path"
            fillRule="nonzero"
          ></path>
          <path
            d="M41.4,34.30092 C41.8,33.87632 42.3,33.34562 42.8,32.70882 C44.1,31.01052 44.8,29.41832 45.3,28.03852 C45.4,27.82622 45.4,27.61392 45.5,27.50782 C45.5,27.50782 47.2,33.55792 49.9,34.30092 L41.4,34.30092 Z"
            id="Path"
            fillRule="nonzero"
          ></path>
          <path
            d="M48.9,2.67035 C44.1654,5.00414 42.7174,7.37403 42.5,9.99422 C42.2825,12.61442 42.9,13.60302 43.7,14.98292 C44.1,15.72592 45.9,17.84882 45.9,17.84882 C45.9,17.84882 49.5,21.24532 52.5,22.73132 C58.2,25.49112 57.3,30.16132 57.3,30.16132 C57.3,30.47982 57.2,30.90432 57,31.43512 C56.5,32.60262 55.8,33.23952 55.3,33.66412 C54.9,33.98252 54.5,34.19482 54.1,34.51322 C54.8,34.51322 56.5,34.51322 58.3,33.34562 C58.7,33.02722 59.9,32.17812 60.8,30.58592 C63,26.44632 61.1232,22.38012 60.2,21.24532 C60.2,21.24532 58.4,18.06102 51.7,14.34602 C45,10.63102 46.4268,6.53898 46.4268,6.53898 C46.4268,6.53898 46.5977,4.62532 48.9,3.20106 C51.2023,1.7768 50.3851,2.17368 50.3851,2.17368 C50.3851,2.17368 49.5922,2.3849 48.9,2.67035 Z"
            id="Path"
            fillRule="nonzero"
          ></path>
          <path
            d="M52.587,2.45801 L61.235,2.45801 C61.235,2.45801 58.735,4.05015 57.335,9.56958 C57.235,9.46344 56.2541,3.4842 52.587,2.45801 Z"
            id="Path"
            fillRule="nonzero"
          ></path>
          <path
            d="M62.3851,2.43476 L70.3999,2.45806 C70.3999,2.45806 69.4999,3.08875 69.4999,4.47478 C69.6999,13.81532 69.7999,23.15592 69.9999,32.49652 C69.9999,33.23952 70.1445,33.56372 70.2445,33.77592 C70.2445,33.77592 70.2769,33.83802 70.2999,33.87632 C70.5102,34.22562 70.8999,34.40702 71.0999,34.51322 L62.4999,34.61932 C62.6999,34.51322 62.9999,34.08862 62.9999,34.08862 C62.9999,34.08862 63.2781,33.95972 63.4999,32.49652 C63.7218,31.03322 63.1999,14.02762 63.0999,4.7932 C63.0999,4.58092 63.0999,4.36863 62.9999,4.05021 C62.7999,3.30721 62.3999,2.77649 62.1999,2.67035 L61.9281,2.43479 C62.4013,2.41148 62.4047,2.43482 62.3851,2.43476 Z"
            id="Path"
            fillRule="nonzero"
          ></path>
          <path
            d="M72.5,18.59182 L76.7,13.81532 L94.2,34.30092 L81.4,34.30092 C81.4,34.30092 83,33.87632 82.4,30.69202 C82.4,30.69202 82.2,29.63062 80.8,28.03852 L72.5,18.59182 Z"
            id="Path"
            fillRule="nonzero"
          ></path>
          <path
            d="M76.8,2.35192 L85.3,2.35192 C85.3,2.35192 79.8001,5.43006 77.9001,9.67578 C77.9001,9.67578 79.4,3.83792 76.8,2.35192 Z"
            id="Path"
            fillRule="nonzero"
          ></path>
          <ellipse
            id="Oval"
            fillRule="nonzero"
            cx="7"
            cy="4.24571"
            rx="4"
            ry="4.24571"
          ></ellipse>
        </g>
      </g>
    </svg>
  );
};
export default Logo;
